(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvHistoryList', drvHistoryList);

    /**
     * @ngdoc directive
     * @name drvHistoryList
     *
     * @description
     * Show a history list.
     *
     * @param {number} masterRecordId - The id of the Item to show history for.
     * @param {object} api - Optional. If provided, will have functions added to it for interacting with the item list:
     *   - {function} refresh - Refresh the item list.
     * @param {function} listUpdated - Optional. Callback, triggered when list is updated.
     * @param {date} dateFrom
     */
    function drvHistoryList() {
        return {
            templateUrl: 'app/history/history-list.tmpl.html',
            scope: {},
            controller: drvHistoryListCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                masterRecordId: '<',
                api: '=',
                listUpdated: '&?',
                dateFrom: '<'
            }
        };
    }

    drvHistoryListCtrl.$inject = ['HistoryService', 'SystemService', 'EntitiesService', 'DialogService', 'PromiseLatest', '$scope'];

    function drvHistoryListCtrl(HistoryService, SystemService, EntitiesService, DialogService, PromiseLatest, $scope) {

        /* jshint validthis:true */
        var drvCtrl = this;

        drvCtrl.updateList = updateList;
        drvCtrl.history = [];
        drvCtrl.historyItemCount = 0;
        drvCtrl.currentPage = 1;
        drvCtrl.pageSize = 10;
        drvCtrl.error = null;
        drvCtrl.loading = false;

        drvCtrl.userEntityTemplateName = 'User';
        drvCtrl.operationTypes = ['Add', 'Edit', 'Event'];
        drvCtrl.searchUser = null;
        drvCtrl.searchOperation = '';
        drvCtrl.searchDetails = '';
        drvCtrl.searchDelay = 0;
        drvCtrl.users = [];

        var updateListPromise = new PromiseLatest();


        activate();

        function activate() {
            drvCtrl.searchDelay = SystemService.getSearchDelay();

            loadUsers();

            if (!_.isNil(drvCtrl.api)) {
                drvCtrl.api.refresh = updateList;
            }

            if (!_.isNil(drvCtrl.masterRecordId)) {
                updateList();
            }

            function searchVariableChanged(newVal, oldVal) {
                if (newVal != oldVal) {
                    updateList();
                }
            }

            $scope.$watch('drvCtrl.searchUser', searchVariableChanged);
            $scope.$watch('drvCtrl.searchOperation', searchVariableChanged);
            $scope.$watch('drvCtrl.searchDetails', searchVariableChanged);
        }
        
        /**
         * Update the history list.
         */
        function updateList() {
            drvCtrl.loading = true;

            updateListPromise.latestOnly(HistoryService.getHistoryForItem({
                masterRecordId: drvCtrl.masterRecordId,
                dateFrom: drvCtrl.dateFrom,
                userId: drvCtrl.searchUser,
                operation: drvCtrl.searchOperation,
                details: drvCtrl.searchDetails,
                pageNumber: drvCtrl.currentPage,
                pageSize: drvCtrl.pageSize
            }))
                .then(getHistoryOk, getHistoryError)
                .finally(function () { drvCtrl.loading = false; });

            function getHistoryOk(items) {
                drvCtrl.history = items.Items;
                drvCtrl.historyItemCount = items.ItemCount;

                if (angular.isFunction(drvCtrl.listUpdated)) {
                    drvCtrl.listUpdated();
                }
            }

            function getHistoryError(response) {
                drvCtrl.error = response;
            }
        }

        /**
         * Load all users.
         */
        function loadUsers() {
            return EntitiesService.query({ entityType: 'User' })
                .then(getUsersOk, getUsersError);

            function getUsersOk(data) {
                drvCtrl.users = data.Entities;

                if (data.Entities.length > 0) {
                    drvCtrl.userEntityTemplateName = data.Entities[0].EntityTemplate.Name;
                }
            }

            function getUsersError(response) {
                DialogService.error('Error fetching Users', response);
            }
        }
    }
})();
